import DictionaryManager from "./DictionaryManager";

export default DictionaryManager;
